import { Component, Prop, Vue } from "vue-property-decorator";
import { ChartConfiguration } from "chart.js";
import Chart from "chart.js";

@Component
export default class ChartTypes extends Vue {
  @Prop() chartData!: ChartConfiguration;
  @Prop() chartId!: string;
  private chartLocalRandId!: string;
  chartInstance!: Chart;

  created() {
    this.chartLocalRandId = this.chartId + Math.random();
  }

  mounted() {
    if (!(this.chartData && this.chartId)) return;
    const ctx: any = document.getElementById(this.chartLocalRandId);
    this.chartInstance = new Chart(ctx, this.chartData);
  }

  forceRefresh() {
    this.chartInstance.update();
  }

  render() {
    return <canvas id={this.chartLocalRandId}></canvas>;
  }
}

const component = ChartTypes;
